import React from 'react';
import clsx from 'clsx';

import { InputLabel } from '../InputLabel/InputLabel';

import styles from './InputBlock.module.scss';

export type InputBlockProps = {
  className?: string;
  mask?: string;
  label?: string;
};

export const InputBlock: React.FC<InputBlockProps> = ({ className, children, mask, label }) => (
  <div className={clsx(styles.root, className, { [styles['have-mask']]: mask })}>
    <InputLabel text={label}>{children}</InputLabel>
    <div className={styles.mask}>{mask}</div>
  </div>
);
